<template>
  <v-dialog v-model="dialogInvite" scrollable persistent max-width="500px">
    <v-card style="border-radius:20px;">
         <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">person_add</v-icon>&nbsp;&nbsp;{{$t('Dialog.group.headerInvite')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="Close">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>

        <v-card-text style="height: 300px; background-color: white;">
        <v-container fluid v-if="!progress">
          <v-layout row wrap>
            <v-flex sm12 md12 lg12 xl12 class="CSChatThai">
              <v-select
                :label="$t('Dialog.group.chooseFriend')"
                :items="FriendList"
                v-model="selected"
                item-text="name"
                item-value="tokenuser"
                multiple
                chips
                max-height="55vh"
                autocomplete
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    close
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi CSChatThai"
                    :key="JSON.stringify(data.item)"
                  >
                    <v-avatar>
                      <img v-if="data.item.profilepicture" :src="data.item.profilepicture">
                      <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png'>
                      <img v-else src='/static/img/default_profile/man-white.png'>
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data" style="max-height: 55vh;" class="scrolling-wrapper">
                  <template v-if="typeof data.item !== 'object'" >
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else >
                    <v-list-tile-avatar >
                      <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="alligator-turtle">
                      <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png'>
                      <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png'>
                      <img v-else src='/static/img/default_profile/man-white.png'>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <div v-else>
          <v-progress-linear :indeterminate="progress"></v-progress-linear>
        </div>
      </v-card-text>
      <v-card-actions >
        <v-spacer></v-spacer>
          <v-btn color="red darken-1" class="CSChatThai" style="text-transform: none;" flat v-on:click="Close()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          <v-btn color="blue darken-1" class="CSChatThai" style="text-transform: none;"  flat @click="invitefriends()">{{$t('AnswerQuestion.ok')}}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
// import { mapState } from 'vuex'
import { Decode } from '@/services'

export default {
  props: {dialogInvite: false, member: '', memberpending: '', group_id: ''},
  data: () => ({
    FriendList: [],
    token: '',
    selected: [],
    progress: false,
    businessidinvite: [],
    listmemberinvite: [],
    tokeninvite: []
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  computed: {
  },
  watch: {
    dialogInvite () {
      if (this.dialogInvite) {
        this.getlist()
      }
    }
  },
  methods: {
    Close () {
      this.$emit('closeInvite', false)
      this.selected = []
    },
    getlist () {
      var _ = require('lodash')
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.token}).then((response) => {
        this.FriendList = response.data['list_friend']
        this.FriendList = _.differenceBy(this.FriendList, this.member, 'tokenuser')
        this.FriendList = _.differenceBy(this.FriendList, this.memberpending, 'tokenuser')
      })
    },
    invitefriends () {
      this.progress = true
      // console.log(this.listmemberinvite)
      // process.env.APIgo_api + '/v1/invite-group'
      // process.env.APImanage + '/invitemembergroup'
      this.axios.post(process.env.APIgo_api + '/v1/invite-group', {group_id: this.group_id, tokenuser: this.token, listmember: this.selected}).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.progress = false
          this.$swal(
            '',
            this.$t('Alert.Success.inviteFriendGroup'),
            'success'
          )
          this.$emit('invitemembergroup')
          this.Close()
        } else {
          this.progress = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          this.Close()
        }
      }, () => {
        this.progress = false
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        this.Close()
      })
    }
  }
}
</script>
<style  lang="css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_group/InviteGroupDialog.vue